module.exports = __webpack_public_path__ + "static/media/peugeot.29477b90.png";